import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

import {CompetitorIqOnboardingModal} from '../onboarding-modal/competitor-iq-onboarding-modal';

export function GetStartedEmptyState() {
    const [isShowingOnboarding, setIsShowingOnboarding] = React.useState<boolean>(false);

    return (
        <div className='full-height flex flex-dir-col justify-center'>
            <EmptyStateLarge
                icon={
                    <div style={{width: '250px'}}>
                        <img
                            className='full-width'
                            src='/include/images/onboarding/competitor-iq-ball-roll.svg'
                        />
                    </div>
                }
                detailTextBullets={[
                    'Dive into CompetitorSpy to gain a deeper understanding of your rivals’ web traffic',
                    'Decode the strategies driving your competitors’ online success',
                    'Navigate the dynamic landscape with insights into competitors’ web traffic trends',
                ]}
                cta={
                    <Button
                        size='xlarge'
                        variant='primary'
                        onClick={() => {
                            setIsShowingOnboarding(true);
                        }}
                    >
                        Get started
                    </Button>
                }
                title='Elevate your insights with CompetitorSpy'
                subtitle='Gain an edge with detailed competitive analysis'
            />
            <CompetitorIqOnboardingModal
                isOpen={isShowingOnboarding}
                onClose={() => {
                    setIsShowingOnboarding(false);
                }}
            />
        </div>
    );
}
